import { Group, Modal, Space } from '@mantine/core';
import { useParams } from 'react-router';
import { Title } from '../../../components/Title';
import { query } from '../../../util/api/query';
import type { BarcodeDto } from '../types/BarcodeDto';
import { BarcodesTable } from './BarcodesTable';
import { NewBarcodeButton } from './NewBarcodeButton';

interface BarcodesModalProps {
	close: () => void;
	isOpened: boolean;
	skuid: string;
}

export function BarcodesModal({ isOpened, close, skuid }: BarcodesModalProps) {
	const { organisation } = useParams();

	const resetAndClose = () => {
		close();
	};

	const barcodesQuery = query<BarcodeDto[]>(
		`${organisation}/barcodes/all/${encodeURIComponent(skuid)}`,
		isOpened,
	);

	return (
		<>
			<Modal
				opened={isOpened}
				onClose={resetAndClose}
				title={
					<Title
						label={
							<>
								BARCODES FOR <i>{skuid}</i>
							</>
						}
					/>
				}
				withCloseButton
				size={'lg'}
				centered
			>
				<Group justify="flex-end">
					<NewBarcodeButton
						skuid={skuid}
						triggerListUpdate={() => {
							barcodesQuery.remove();
							barcodesQuery.refetch();
						}}
					/>
				</Group>
				<BarcodesTable barcodesQuery={barcodesQuery} skuid={skuid} />
				<Space h={20} />
			</Modal>
		</>
	);
}
